import { forEach, uniqBy } from 'lodash';
import { BODY_TYPE_FILTER_CATEGORY, SEATS_FILTER_CATEGORY, PROVINCES_AVAILABLE_FILTER_CATEGORY, } from '../../../core/reducers/vehicleListFilters';
const getFilters = (filters, category, name) => {
    var _a, _b;
    if (filters && !((_a = filters[category]) === null || _a === void 0 ? void 0 : _a.includes(name))) {
        (_b = filters[category]) === null || _b === void 0 ? void 0 : _b.push(name);
    }
};
const getVehiclesForStore = (catalog) => {
    if (!catalog)
        return [];
    // exclude models that have no model years or filters
    const validModels = catalog
        .filter(model => model.modelYears.length)
        .filter(model => model.modelYears.some((modelYear) => modelYear.trims.some(trim => { var _a; return (_a = trim.filters) === null || _a === void 0 ? void 0 : _a.items.length; })));
    const result = [];
    forEach(validModels, model => {
        if (!model)
            return;
        forEach(model.modelYears, modelYear => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            const { defaultTrim } = modelYear;
            if (!defaultTrim || !defaultTrim.fields)
                return;
            const trimName = (_a = modelYear.trims.find(trim => trim.detKey.value === defaultTrim.fields.detKey.value)) === null || _a === void 0 ? void 0 : _a.name;
            const { defaultTransmission } = defaultTrim.fields;
            const transmissions = [
                {
                    transmissionKey: defaultTransmission.item.detKey.value,
                    modelCode: defaultTransmission.item.modelCode.value,
                    detIdentifier: '',
                    transmissionName: '',
                    exteriorColorKey: (_f = (_e = (_d = (_c = (_b = defaultTransmission.item.defaultExteriorColor) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d.item) === null || _e === void 0 ? void 0 : _e.detKey) === null || _f === void 0 ? void 0 : _f.value,
                    interiorColorKey: (_j = (_h = (_g = defaultTransmission.item.defaultExteriorColor) === null || _g === void 0 ? void 0 : _g.item) === null || _h === void 0 ? void 0 : _h.defaultInteriorColor) === null || _j === void 0 ? void 0 : _j.interiorColor.color.fields.detKey.value,
                },
            ];
            const vehicle = {
                modelName: model.modelName.value,
                modelYear: modelYear.year.value,
                trimKey: defaultTrim.fields.detKey.value,
                trimName: trimName || '',
                trimGtmName: trimName || '',
                trimImage: {
                    primaryThumbnail: (_l = (_k = modelYear.defaultTrim.fields.primaryThumbnail) === null || _k === void 0 ? void 0 : _k.item) === null || _l === void 0 ? void 0 : _l.value,
                    secondaryThumbnail: (_o = (_m = modelYear.defaultTrim.fields.secondaryThumbnail) === null || _m === void 0 ? void 0 : _m.item) === null || _o === void 0 ? void 0 : _o.value,
                },
                filters: {
                    [BODY_TYPE_FILTER_CATEGORY]: [],
                    [SEATS_FILTER_CATEGORY]: [],
                },
                driveRange: (_p = model.driveRange) === null || _p === void 0 ? void 0 : _p.value,
                modelKey: model.detKey.value,
                detIdentifier: model.detIdentifier.value,
                defaultTransmission: defaultTransmission.item.detKey.value || '',
                transmissions,
            };
            // Include available provinces in the vehicle filters
            const availableProvinces = (_q = model.availableProvinces) === null || _q === void 0 ? void 0 : _q.items.map(province => province.name);
            if (vehicle.filters)
                vehicle.filters[PROVINCES_AVAILABLE_FILTER_CATEGORY] = availableProvinces || [];
            // ensure the body and seats types from all trims are added to the vehicle
            forEach(modelYear.trims, trim => {
                var _a, _b;
                const bodyTypeFilters = (_a = trim.filters) === null || _a === void 0 ? void 0 : _a.items.filter((filter) => { var _a; return ((_a = filter.filterCategory) === null || _a === void 0 ? void 0 : _a.name) === BODY_TYPE_FILTER_CATEGORY; });
                const seatsFilters = (_b = trim.filters) === null || _b === void 0 ? void 0 : _b.items.filter((filter) => { var _a; return ((_a = filter.filterCategory) === null || _a === void 0 ? void 0 : _a.name) === SEATS_FILTER_CATEGORY; });
                if (!bodyTypeFilters.length && !seatsFilters.length)
                    return;
                // add bodyType filter to vehicle
                bodyTypeFilters.forEach(bodyTypeFilter => {
                    const bodyType = bodyTypeFilter.name;
                    getFilters(vehicle.filters, BODY_TYPE_FILTER_CATEGORY, bodyType);
                    result.push(vehicle);
                });
                // add seat filter to vehicle
                seatsFilters.forEach(seatsFilter => {
                    const seats = seatsFilter.name;
                    getFilters(vehicle.filters, SEATS_FILTER_CATEGORY, seats);
                    result.push(vehicle);
                });
            });
        });
    });
    return uniqBy(result, 'trimKey');
};
export default getVehiclesForStore;
